import BlukSkype from "../Assets/images/offers-icons/BlukSkype.svg";
import BlukTelegram from "../Assets/images/offers-icons/BlukTelegram.svg";
import BlukWhatsapp from "../Assets/images/offers-icons/BlukWhatsapp.svg";
import MainPage from "../Assets/images/offers-icons/mainPage.svg";
import pinDown from "../Assets/images/offers-icons/pinDown.svg";
import PinUp from "../Assets/images/offers-icons/PinUp.svg";
import searchResult from "../Assets/images/offers-icons/searchResult.svg";
import skypeGroup from "../Assets/images/offers-icons/skypeGroup.svg";
import ticket from "../Assets/images/offers-icons/ticket.svg";
import whatsappGroup from "../Assets/images/offers-icons/whatsappGroup.svg";
import emailGroup from "../Assets/images/offers-icons/emailBulk.svg";

export const showIconByServiceId = (id) => {
  if (id === 6) {
    return BlukSkype;
  }
  if (id === 7) {
    return BlukTelegram;
  }
  if (id === 5) {
    return BlukWhatsapp;
  }
  if (id === 8) {
    return emailGroup;
  }
  if (id === 9) {
    return MainPage;
  }
  if (id === 11) {
    return pinDown;
  }
  if (id === 10) {
    return PinUp;
  }
  if (id === 1) {
    return searchResult;
  }
  if (id === 2) {
    return skypeGroup;
  }
  if (id === 4) {
    return ticket;
  }
  if (id === 3) {
    return whatsappGroup;
  }
};
